import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from '../services/api';
import '../styles/StaffPages.css';
import headerImage from '../assets/images/header.png';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isMobilePath, setIsMobilePath] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    setIsMobilePath(path.startsWith('/mobile/'));
  }, []);

  const openMobileApp = () => {
    const settingsUrl = 'https://app.gethomecrowd.com/mobile/profile/account-settings';
    window.location.href = settingsUrl;
  };

  useEffect(() => {
    const verifyToken = async () => {
      let token = searchParams.get('token');
      
      if (!token) {
        const currentUrl = window.location.href;
        const urlParams = new URLSearchParams(currentUrl.split('?')[1] || '');
        token = urlParams.get('token');
        
        if (!token) {
          const tokenMatch = currentUrl.match(/[?&]token=([^&]+)/);
          if (tokenMatch) {
            token = decodeURIComponent(tokenMatch[1]);
          }
        }
      }
      
      if (!token) {
        setStatus('error');
        setError('Verification token not found in the link');
        return;
      }

      try {
        const response = await apiService.verifyEmail(token);
        setStatus('success');
        setMessage(response.message || 'Email successfully verified!');
      } catch (error) {
        setStatus('error');
        if (error.response?.data?.error) {
          setError(error.response.data.error);
        } else {
          setError('An error occurred while verifying email. Please try again.');
        }
      }
    };

    verifyToken();
  }, [searchParams]);

  return (
    <div className="d-flex align-center justify-center" style={{ minHeight: '100vh' }}>
      <div className="container-narrow">
        <div className="card" style={{ maxWidth: '500px', margin: '0 auto', padding: '32px' }}>
          <div className="text-center mb-4">
            <img src={headerImage} alt="Homecrowd" style={{ maxWidth: '250px', height: 'auto', marginBottom: '20px' }} />
          </div>

          {status === 'loading' && (
            <div className="text-center">
              <div style={{ marginBottom: '20px' }}>
                <div className="spinner" style={{ 
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #00C8FF',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  animation: 'spin 1s linear infinite',
                  margin: '0 auto'
                }}></div>
              </div>
              <p style={{ fontSize: '16px', color: '#4b5563' }}>Verifying email...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center">
              <div style={{ 
                width: '80px', 
                height: '80px', 
                borderRadius: '50%', 
                backgroundColor: '#10b981',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg 
                  width="40" 
                  height="40" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="white" 
                  strokeWidth="3" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h2 style={{ 
                fontSize: '24px', 
                fontWeight: '700', 
                color: '#111111',
                marginBottom: '12px'
              }}>
                Email verified!
              </h2>
              <p style={{ 
                fontSize: '16px', 
                color: '#4b5563',
                marginBottom: '32px',
                lineHeight: '1.6'
              }}>
                {message}
              </p>
              {isMobilePath && (
                <button
                  onClick={openMobileApp}
                  className="staff-page-button"
                  style={{ width: '100%', justifyContent: 'center', marginBottom: '12px' }}
                >
                  <span className="staff-page-button-text">
                    Return to mobile app
                  </span>
                </button>
              )}
            </div>
          )}

          {status === 'error' && (
            <div className="text-center">
              <div style={{ 
                width: '80px', 
                height: '80px', 
                borderRadius: '50%', 
                backgroundColor: '#ef4444',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg 
                  width="40" 
                  height="40" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="white" 
                  strokeWidth="3" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <h2 style={{ 
                fontSize: '24px', 
                fontWeight: '700', 
                color: '#111111',
                marginBottom: '12px'
              }}>
                Verification error
              </h2>
              <p style={{ 
                fontSize: '16px', 
                color: '#4b5563',
                marginBottom: '32px',
                lineHeight: '1.6'
              }}>
                {error}
              </p>
              <button
                onClick={() => navigate('/login/')}
                className="staff-page-button"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                <span className="staff-page-button-text">
                  Return to login page
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default VerifyEmail;
